import Token from '@/utils/Token';

export default {
    permissoes() {
        return axios.get('/api/auth/permissoes', Token.getHeader());
    },
    login(params) {
        return axios.post('/api/login', params);
    },
    logout() {
        return axios.post('/api/logout', {}, Token.getHeader());
    },
    esqueciSenha(params) {
        return axios.post('/api/esqueci-senha', params);
    },

    me() {
        return axios.get('/api/auth', Token.getHeader());
    },
    profile(params) {
        return axios.post('/api/auth', params, Token.getHeader());
    },
    password(params) {
        return axios.post('/api/auth/password', params, Token.getHeader());
    },
    alterarSenha(params) {
        return axios.post('/api/alterar-senha', params);
    }
}
